import { gql } from '@apollo/client'

import { FRAGMENT_SENTIMENT, FRAGMENT_SENTIMENT_POSTS_V2 } from '../fragments/sentiment'
import { FRAGMENT_WORKSPACE } from '../fragments/workspace'

export const GET_WORKSPACE_SENTIMENT_V2 = gql`
  query getWorkspaceSentimentV2(
    $filters: TerritorySentimentTitleFilters
    $filtersPosts: TerritoryMostEngagedFilters
    $territoryIds: [ID!]
  ) {
    getWorkspace {
      ...FragmentWorkspace
      workspaceBrand: workspaceBrandV2 {
        id
        name
        workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
          earnedTerritory {
            territoryId
            ...FragmentSentiment
            ...FragmentSentimentPostsV2
          }
        }
      }
    }
  }
  ${FRAGMENT_WORKSPACE}
  ${FRAGMENT_SENTIMENT}
  ${FRAGMENT_SENTIMENT_POSTS_V2}
`
